import { EventEmitter } from 'events';
import { isTokenExpired } from '../utils/Jwt';
import Api from '../utils/Api';

const TOKEN_KEY_NAME = 'authToken';
const PROFILE_KEY_NAME = 'profile';

export const SESSION_UPDATED = 'session_updated';

class Auth extends EventEmitter {
  constructor() {
    super();

    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  logout() {
    this.unsetSession();
    this.emit(SESSION_UPDATED);
  }

  login(token) {
    this.setToken(token);

    Api.getSession()
      .then(data => {
        this.setProfile(data);
        this.emit(SESSION_UPDATED);
      })
      .catch(() => {
        this.logout();
      });
  }

  setToken(token) {
    localStorage.setItem(TOKEN_KEY_NAME, token);
  }

  getToken() {
    return localStorage.getItem(TOKEN_KEY_NAME);
  }

  unsetSession() {
    localStorage.removeItem(TOKEN_KEY_NAME);
    localStorage.removeItem(PROFILE_KEY_NAME);
  }

  setProfile(data) {
    localStorage.setItem(PROFILE_KEY_NAME, JSON.stringify(data));
  }

  getProfile() {
    return JSON.parse(localStorage.getItem(PROFILE_KEY_NAME));
  }

  isAuthenticated() {
    const token = this.getToken();

    return token && !isTokenExpired(token);
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/services/Auth.js